import React from 'react';
import { Link } from 'react-router-dom';
import { RoutesPanel } from '../../Security/ProtectedRoute';
import '../../styles/Panel.css';

/**
 * Se muestra cuando `RutaProtegidaPanel` bloquea el acceso por rol
 * insuficiente (usuario autenticado, pero sin el rol que la pantalla exige).
 */
const SinPermiso = () => (
  <div className="panel-sin-permiso">
    <h2>No tienes permiso para ver esta página</h2>
    <p className="panel-texto-ayuda">Tu rol actual no tiene acceso a esta sección del panel.</p>
    <Link to={RoutesPanel.INICIO} className="panel-boton-primario panel-link-boton">
      Volver al panel
    </Link>
  </div>
);

export default SinPermiso;
